<h2 style="margin:5px 0 10px 0;">Create a New Location Status</h2>
<form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
  <fieldset [disabled]="isReadOnly$ | async">
    <table cellspacing="2" class="attribute-full-width">
      <tr>
        <td>
          <mat-form-field>
            <input
              [attr.data-testid]="'location_status_name_text'"
              formControlName="name"
              matInput
              placeholder="Location Status Name"
              required
              />
            @if (form.get('name').invalid) {
              <mat-error>
                Please enter a Name
              </mat-error>
            }
          </mat-form-field>
        </td>
        <td>
          <mat-form-field>
            <input
              [attr.data-testid]="'location_status_tag_text'"
              formControlName="tag"
              matInput
              pattern="^[A-Z_0-9]*$"
              placeholder="Location Status Tag"
              required
              (focusout)="findTagExists()"
              >
            @if (form.get('tag').invalid && !form.get('tag').value) {
              <mat-error>
                Please enter a Standard Tag
              </mat-error>
            }
            @if (form.get('tag').hasError('pattern') && form.get('tag').value) {
              <mat-error>
                Please enter a Valid Standard Tag
              </mat-error>
            }
            @if (form.get('tag').hasError('tagExists') && form.get('tag').touched) {
              <mat-error>
                Tag already exists! Create a new one.
              </mat-error>
            }
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td>
          <mat-form-field>
            <mat-select
              [attr.data-testid]="'location_status_subtype_text'"
              formControlName="subType"
              placeholder="Location Status Sub Type"
              required
              (selectionChange)="selectSubType($event.value)"
              >
              @for (subType of subTypes; track subType) {
                <mat-option [value]="subType.value">
                  {{subType.label}}
                </mat-option>
              }
            </mat-select>
            @if (form.get('subType').invalid) {
              <mat-error>
                Please enter a Sub Type
              </mat-error>
            }
          </mat-form-field>
        </td>
        <td>
          <mat-form-field>
            <mat-select
              [attr.data-testid]="'location_status_category'"
              formControlName="category"
              placeholder="Location Status Category"
              required
              >
              @for (category of categories; track category) {
                <mat-option [value]="category">
                  {{category}}
                </mat-option>
              }
            </mat-select>
            @if (form.get('category').invalid) {
              <mat-error>
                Please enter a Category
              </mat-error>
            }
          </mat-form-field>
        </td>
      </tr>
      <tr>
        @if (showStatusMessage$  | async) {
          <td>
            <mat-form-field appearance="outline">
              <textarea
                [attr.data-testid]="'location_status_status_message_text'"
                formControlName="statusMessage"
                matInput
                matAutosizeMaxRows="6"
                matAutosizeMinRows="3"
                matTextareaAutosize
                placeholder="Location Status Message"
              ></textarea>
              <mat-hint>e.g. Inventory Outage Message</mat-hint>
              @if (form.get('subType').value === 'MESSAGING' && form.get('statusMessage').invalid) {
                <mat-error>
                  Please enter a Status Message
                </mat-error>
              }
            </mat-form-field>
          </td>
        }
        @if (showSubCategory$ | async) {
          <td>
            <mat-form-field>
              <mat-select
                [attr.data-testid]="'location_status_sub_category'"
                formControlName="subCategory"
                placeholder="Location Status Sub Category"
                >
                @for (subCategory of subCategories; track subCategory) {
                  <mat-option [value]="subCategory">
                    {{subCategory}}
                  </mat-option>
                }
              </mat-select>
              @if (form.get('subCategory').invalid) {
                <mat-error>
                  Please enter a Sub Category
                </mat-error>
              }
            </mat-form-field>
          </td>
        }
      </tr>
    </table>
    <div  style="margin-top: 30px;" class="flex-center-center">
      <button
        [attr.data-testid]="'cancel_button'"
        class="button-color"
        mat-raised-button
        matTooltip="Cancel creating Location Status"
        type="button"
        style="margin-right: 60px;"
        (click)="onNoClick()"
        >
        Cancel
      </button>
      <button
        [attr.data-testid]="'save_button'"
        class="button-color"
        [disabled]="(isReadOnly$ | async) || form.invalid"
        mat-raised-button
        matTooltip="Submit Location Status"
        type="submit"
        >
        Save
      </button>
    </div>
  </fieldset>
</form>
